import React from 'react';
import { AosAnimation } from '../../../shared/components/fader/fader';

const AboutTeamComponent = ({ team_section_content, team_section_logo, team_section_title }) => {
    return (<>
        <div className="information-box about-team text-center">
            <div className="container">
                <div className="intro-box">
                    {
                        team_section_title &&
                        <h2 className="heading">{ team_section_title }</h2>
                    }
                    {
                        team_section_logo &&
                        <AosAnimation animationType="fade-up" duration={ 1000 }>
                            {/* <img src={ `${process.env.PUBLIC_URL}/images/career-demivolt.svg` } alt="animated-1" /> */ }
                            <img src={ team_section_logo.url } alt="animated-1" />
                        </AosAnimation>
                    }
                    {
                        team_section_content &&
                        <AosAnimation animationType="fade-up" duration={ 1200 } cascade>
                            <div dangerouslySetInnerHTML={ { __html: team_section_content } } />
                        </AosAnimation>
                    }
                </div>
            </div>
        </div>
    </>);
};

export default AboutTeamComponent;